import { Box } from '@mui/material';
import React from 'react';
import BaseVideo from 'components/video/BaseVideo';
import { useMediaQuery } from '@mui/system';
import appTheme from 'ui-blocks/AppTheme';
import { reusableStyles } from 'ui-blocks/ReusableStyles';
import { ReactComponent as NarratorIcon } from 'assets/svg/narrator-icon.svg';
import BaseTypography from 'components/typography/BaseTypography';
import { baseUrl } from 'constants/Constants';
import { narratorSectionStyles } from '../narratorSectionStyles';

const narratorSource = {
	src: `${process.env.REACT_APP_S3_BASE_OPTIMUX_URL}/18_july/narrator/vid_1.mp4?fallbackUrl=${baseUrl}/narrator/vid_1.mp4`,
	thumbnail: `${process.env.REACT_APP_S3_BASE_OPTIMUX_URL}/18_july/narrator/img_1.webp?fallbackUrl=${baseUrl}/narrator/img_1.webp`,
};
export default function CharacterNarratorVideo() {
	const isMobile = useMediaQuery(appTheme.breakpoints.down('mobileMid'));

	return (
		<Box
			id="character-narrator-video-container"
			sx={[reusableStyles.flexCol, { width: { xs: '100%', mobileUi: '75%', xxl: '65%' } }]}
		>
			<Box id="character-narrator-video" sx={{ width: '100%' }}>
				<BaseVideo
					src={narratorSource.src}
					poster={narratorSource.thumbnail}
					controls={false}
					autoPlay
					muted
					loop
					playPauseIcon={false}
					showSkeletonLoading
					playsInline
					style={{
						...narratorSectionStyles.baseVideo,
						borderTopLeftRadius: isMobile ? '16px' : '32px',
						borderTopRightRadius: isMobile ? '16px' : '32px',
					}}
					containerStyle={narratorSectionStyles.baseVideoContainerStyle}
				/>
			</Box>
			<Box
				id="narrator-video-description"
				sx={[
					reusableStyles.flexColWithGap(16),
					reusableStyles.flexCenter,
					narratorSectionStyles.videoDescriptionContainer,
				]}
			>
				<NarratorIcon />
				<BaseTypography
					variant={isMobile ? 'b3_regular' : 't2_regular'}
					styles={{ color: 'colors.light4', textAlign: 'center' }}
				>
					Hey there! Just brewed some coffee and made this video—without a camera crew. Yep, it’s
					all AI. Kinda wild, right?
				</BaseTypography>
			</Box>
		</Box>
	);
}
